module.exports = __webpack_public_path__ + "static/media/logo-essilor.d251d134.png";